import React from 'react';

interface EntryTemplatesFieldChipProps {
  name: string;
}

export default function EntryTemplatesFieldChip({name}: EntryTemplatesFieldChipProps): JSX.Element {
  return (
    <div className="file-tag">
      <span>{name}</span>
    </div>
  );
}
